module.exports = __webpack_public_path__ + "media/images/advisor/img_7_3-74815e75313c76fc223db54dc08dc04a.png";